import React from "react";
import classes from "./CurrencyBadge.module.css";
import { currencyCode } from "../utils/formatters";

/**
 * A small pill naming the currency a block of figures is denominated in.
 *
 * Two independent balances sitting next to each other only read as two balances if each one says
 * which currency it is. Without the badge the eye treats the smaller figure as a subtotal of the
 * larger, which is exactly the mistake every screen here is built to prevent.
 *
 * The `subtle` tone is for a badge that sits *inside* a figure (the EUR line of a `DualMoney`);
 * the default tone is for one that heads a whole block.
 */
export type CurrencyBadgeProps = {
	currencyId?: number | null;
	tone?: "brand" | "subtle";
	className?: string;
};

const CurrencyBadge: React.FC<CurrencyBadgeProps> = ({
	currencyId,
	tone = "brand",
	className,
}) => (
	<span
		className={`${classes.badge} ${
			tone === "subtle" ? classes.subtle : classes.brand
		} ${className ?? ""}`}
	>
		{currencyCode(currencyId)}
	</span>
);

export default CurrencyBadge;
